module.exports = __webpack_public_path__ + "static/media/print-sgombero-detail1.989e7595.jpg";